export default {
  EXISTS_PRODUCT: `#graphql
  query existsProduct($product: String!) {
    existsProduct(product: $product)           
  }`,

  GET_BY_PRODUCT: `#graphql
  query getByProduct($product: String) {
    getByProduct(product: $product)
    { 
      product,
      brand,
      article,
      person,
      design,
      priceUnit,
      priceThree,
      priceThreeCommunity,
      priceWholesaler,
      priceSale,
      priceSaleCommunity,
      colors,
      folder,
      subfolder,
      images,
      measurementsText,
      measurementsImage,
      imagesMeasure,
      texts,
      description,
      title,
      conditions,
      material,
      active,
      sizes,
      quantityAvailable,
      keywords,
      pinned,
      old
    }            
  }`,

  GET_TIERS_BY_PRODUCT: `#graphql
  query getByProduct($product: String) {
    getByProduct(product: $product)
    { 
      sizes,
      tiers,
      showLast
    }            
  }`,

  ENABLE_LAST_PRODUCT: `#graphql
  mutation enableLastProduct($nameProduct: String!, $brand: String!, $size: String!, $enable: Boolean!) {
    enableLastProduct(nameProduct: $nameProduct, brand: $brand, size: $size, enable: $enable)        
  }`,

  GET_IMAGES_BY_PRODUCT: `#graphql
  query getByProduct($product: String) {
    getByProduct(product: $product)
    { 
      brand
      folder
      subfolder
      images
    }            
  }`,

  GET_DATA_RELATED: `#graphql
  query getProductsRelated($article: String, $person: String, $brand: String) {
    getProductsRelated(article: $article, person: $person, brand: $brand)
    { 
      product,
      images
    }            
  }`,

  GET_ALL: `#graphql
  query getProducts($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getProducts(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        product,
        brand,
        article,
        person,
        design,
        priceUnit,
        priceThree,
        priceThreeCommunity,
        priceWholesaler,
        priceSale,
        priceSaleCommunity,
        cost,
        colors,
        folder,
        subfolder,
        images,
        measurementsText,
        measurementsImage,
        imagesMeasure,
        texts,
        description,
        title,
        conditions,
        material,
        active,
        sizes,
        tiers,
        quantityAvailable,
        pendingOrders,
        picked,
        errorStock,
        inStock,
        totalAvailable,
        order,
        suborder,
        group,
        isEcological,
        isClearence,
        ecologicalDescription,
        update,
        keywords,
        pinned,
        old,
        showLast,
        isWinner,
        orderWinner,
        lastUnits,
        variants {
          product,
          color,
          colorName
        }
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getProductsHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getProductsHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        product,
        brand,
        article,
        person,
        design,
        priceUnit,
        priceThree,
        priceThreeCommunity,
        priceWholesaler,
        priceSale,
        priceSaleCommunity,
        cost,
        colors,
        folder,
        subfolder,
        measurementsText,
        measurementsImage,
        imagesMeasure,
        texts,
        description,
        images,
        active,
        sizes,
        tiers,
        order,
        suborder,
        group,
        isEcological,
        isClearence,
        ecologicalDescription,
        quantityAvailable,
        pendingOrders,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewProduct($product: ProductInput!) {
    newProduct(input: $product)
    {
      product,
      brand,
      article,
      person,
      design,
      priceUnit,
      priceThree,
      priceWholesaler,
      priceSale,
      colors,
      folder,
      subfolder,
      measurementsText,
      measurementsImage,
      imagesMeasure,
      texts,
      description,
      images,
      active,
      variants {
        product,
        color
      }
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateProduct($product: String!, $productUpdate: ProductUpdateInput!) {
    updateProduct(product:$product, productUpdate: $productUpdate)
    {
      product
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteProduct($product: String!) {
    deleteProduct(product:$product)
    {
      product
    }            
  }`,

  REPLICATE: `#graphql
  mutation ReplicateProduct($product: String!, $count: Int!, $colors: [String!]!, $syncVariants: Boolean!) {
    replicateProduct(product: $product, count: $count, colors: $colors, syncVariants: $syncVariants) {
      product
      brand
      variants {
        product
        color
      }
    }
  }`,

  DELETE_PRODUCT_SIZE: `#graphql
  mutation DeleteProductSize($product: String!, $size: String!) {
    deleteProductSize(product: $product, size: $size) {
      product
      sizes
      quantityAvailable
      tiers
      pendingOrders
      showLast
      inStock
      totalAvailable
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/product.js